/** @param {string} text */
export async function copyToClipboard(text) {
  if (!text) return false;
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    try {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.setAttribute("readonly", "");
      textarea.style.position = "absolute";
      textarea.style.left = "-9999px";
      document.body.appendChild(textarea);
      textarea.select();
      const ok = document.execCommand("copy");
      document.body.removeChild(textarea);
      return ok;
    } catch {
      return false;
    }
  }
}

/**
 * @param {{ url: string, title?: string, text?: string }} payload
 * @returns {boolean}
 */
export function canUseNativeShare(payload) {
  return (
    typeof navigator !== "undefined" &&
    typeof navigator.share === "function" &&
    Boolean(payload.url)
  );
}

/**
 * @param {{ url: string, title?: string, text?: string }} payload
 */
export async function nativeShare(payload) {
  if (!canUseNativeShare(payload)) return false;
  await navigator.share({
    url: payload.url,
    title: payload.title || undefined,
    text: payload.text || undefined,
  });
  return true;
}

/**
 * @param {'email' | 'facebook' | 'twitter' | 'linkedin' | 'whatsapp'} platform
 * @param {{ url: string, title?: string, text?: string }} payload
 */
export function buildSocialShareUrl(platform, { url, title = "", text = "" }) {
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);
  const line = [title, text].filter(Boolean).join(" — ");

  switch (platform) {
    case "email":
      return `mailto:?subject=${encodedTitle}&body=${encodeURIComponent(
        line ? `${line}\n\n${url}` : url
      )}`;
    case "facebook":
      return `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
    case "twitter":
      return `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodeURIComponent(
        line || title || text
      )}`;
    case "linkedin":
      return `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`;
    case "whatsapp": {
      const message = line ? `${line} ${url}` : url;
      return `https://wa.me/?text=${encodeURIComponent(message)}`;
    }
    default:
      return url;
  }
}

export function openShareWindow(href) {
  if (!href) return;
  if (href.startsWith("mailto:")) {
    window.location.href = href;
    return;
  }
  window.open(href, "_blank", "noopener,noreferrer,width=600,height=480");
}
